if(!customElements.get('page-content')) {
  class PageContent extends HTMLElement {
    constructor() {
      super();
    }

    replaceLinksWithButtons(links) {
      if(!links.length) return;
      links.forEach(link => {
        if(link.innerHTML.includes('{button}')) {
          link.innerHTML = link.innerHTML.replace('{button}', '');
          link.classList.add('button', 'button--primary');
        }
      });
    }

    connectedCallback() {
      const rte = document.querySelector('.js-rte');
      const links = rte.querySelectorAll('a');
      this.replaceLinksWithButtons(links);
    }
  }

  customElements.define('page-content', PageContent);
}
